import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConvertMediaMutationVariables = Types.Exact<{
  gs_uri: Types.Scalars['String']['input'];
  file_key: Types.Scalars['String']['input'];
  mime_type: Types.Scalars['String']['input'];
  file_name: Types.Scalars['String']['input'];
}>;


export type ConvertMediaMutation = { __typename?: 'mutation_root', convert_media?: { __typename?: 'ConvertMediaOutput', success: boolean, gs_uri?: string | null, public_url?: string | null, file_key?: string | null, mime_type?: string | null, error?: string | null } | null };


export const ConvertMediaDocument = gql`
    mutation ConvertMedia($gs_uri: String!, $file_key: String!, $mime_type: String!, $file_name: String!) {
  convert_media(
    gs_uri: $gs_uri
    file_key: $file_key
    mime_type: $mime_type
    file_name: $file_name
  ) {
    success
    gs_uri
    public_url
    file_key
    mime_type
    error
  }
}
    `;
export type ConvertMediaMutationFn = Apollo.MutationFunction<ConvertMediaMutation, ConvertMediaMutationVariables>;

/**
 * __useConvertMediaMutation__
 *
 * To run a mutation, you first call `useConvertMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertMediaMutation, { data, loading, error }] = useConvertMediaMutation({
 *   variables: {
 *      gs_uri: // value for 'gs_uri'
 *      file_key: // value for 'file_key'
 *      mime_type: // value for 'mime_type'
 *      file_name: // value for 'file_name'
 *   },
 * });
 */
export function useConvertMediaMutation(baseOptions?: Apollo.MutationHookOptions<ConvertMediaMutation, ConvertMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertMediaMutation, ConvertMediaMutationVariables>(ConvertMediaDocument, options);
      }
export type ConvertMediaMutationHookResult = ReturnType<typeof useConvertMediaMutation>;
export type ConvertMediaMutationResult = Apollo.MutationResult<ConvertMediaMutation>;
export type ConvertMediaMutationOptions = Apollo.BaseMutationOptions<ConvertMediaMutation, ConvertMediaMutationVariables>;